import { useCallback } from "react";

let popupCheckResult: boolean | null = null;
export function usePopupCheck() {
  const checkPopups = useCallback(async (): Promise<boolean> =>  new Promise((resolve) => {
      const test = window.open("", "", "width=100,height=100");
      if (test) {
        test.close();
        resolve(true);
      } else {
        resolve(false);
      }
    }), []);

  const checkPopupsOnce = (): Promise<boolean> => {
    if (popupCheckResult !== null) {
      return Promise.resolve(popupCheckResult);
    }

    const test = window.open("", "", "width=100,height=100");
    if (test) {
      test.close();
      popupCheckResult = true;
    } else {
      popupCheckResult = false;
    }

    return Promise.resolve(popupCheckResult);
  };

  return { checkPopups, checkPopupsOnce };
}



